module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1055-1ccddc633e058ca78b7bf02e9f93dadd.png";